// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-dialog {
  background: var(--color-bg, #fff);
  border: 1px solid var(--color-border, #ddd);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  min-width: 340px;
  max-width: 480px;
  overflow: hidden;
}
.confirm-header {
  padding: 12px 16px;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid var(--color-border, #eee);
  background: var(--color-bg-secondary, #f8f9fa);
  color: var(--color-text, #333);
}
.confirm-body {
  padding: 16px;
  font-size: 13px;
  color: var(--color-text, #333);
  line-height: 1.5;
}
.confirm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid var(--color-border, #eee);
}
.confirm-btn {
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid var(--color-border, #ddd);
  background: var(--color-bg, #fff);
  color: var(--color-text, #333);
  transition: background 0.15s;
}
.confirm-btn:hover {
  background: var(--color-bg-tertiary, #f0f0f0);
}
/* Enter 가 누를 단추가 어느 것인지 보여야 한다 */
.confirm-btn:focus-visible,
.confirm-btn:focus {
  outline: 2px solid rgba(59, 130, 246, 0.55);
  outline-offset: 2px;
}
.confirm-btn-primary {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}
.confirm-btn-primary:hover {
  background: #0056b3;
}
.confirm-btn-danger {
  background: #dc3545;
  color: #fff;
  border-color: #dc3545;
}
.confirm-btn-danger:hover {
  background: #c82333;
}

[data-theme="dark"] .confirm-overlay { background: rgba(0,0,0,0.6); }
[data-theme="dark"] .confirm-dialog { background: var(--color-bg-tertiary); border-color: var(--color-border); }
[data-theme="dark"] .confirm-header { background: var(--color-bg-secondary); color: var(--color-text); border-color: var(--color-border); }
[data-theme="dark"] .confirm-body { color: var(--color-text); }
[data-theme="dark"] .confirm-footer { border-color: var(--color-border); }
[data-theme="dark"] .confirm-btn { background: var(--color-btn-bg); color: var(--color-text); border-color: var(--color-btn-border); }
[data-theme="dark"] .confirm-btn:hover { background: var(--color-hover); }
/* 다크에서도 주 버튼은 색을 지킨다 — 위 규칙이 더 구체적이라 위험(빨강)·기본(파랑)까지 회색으로 덮어,
   되돌릴 수 없는 동작(삭제·초기화)의 버튼이 「취소」 와 똑같이 보였다(화면 확인 2026-10-05) */
[data-theme="dark"] .confirm-btn-primary { background: #1f6feb; color: #fff; border-color: #1f6feb; }
[data-theme="dark"] .confirm-btn-primary:hover { background: #388bfd; }
[data-theme="dark"] .confirm-btn-danger { background: #da3633; color: #fff; border-color: #da3633; }
[data-theme="dark"] .confirm-btn-danger:hover { background: #f85149; }
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,8CAA8C;EAC9C,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,6CAA6C;AAC/C;AACA,iCAAiC;AACjC;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC,2BAA2B,EAAE;AACpE,sCAAsC,oCAAoC,EAAE,iCAAiC,EAAE;AAC/G,sCAAsC,qCAAqC,EAAE,wBAAwB,EAAE,iCAAiC,EAAE;AAC1I,oCAAoC,wBAAwB,EAAE;AAC9D,sCAAsC,iCAAiC,EAAE;AACzE,mCAAmC,+BAA+B,EAAE,wBAAwB,EAAE,qCAAqC,EAAE;AACrI,yCAAyC,8BAA8B,EAAE;AACzE;8DAC8D;AAC9D,2CAA2C,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AACpG,iDAAiD,mBAAmB,EAAE;AACtE,0CAA0C,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AACnG,gDAAgD,mBAAmB,EAAE","sourcesContent":[".confirm-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.4);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.confirm-dialog {\n  background: var(--color-bg, #fff);\n  border: 1px solid var(--color-border, #ddd);\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  min-width: 340px;\n  max-width: 480px;\n  overflow: hidden;\n}\n.confirm-header {\n  padding: 12px 16px;\n  font-weight: 600;\n  font-size: 13px;\n  border-bottom: 1px solid var(--color-border, #eee);\n  background: var(--color-bg-secondary, #f8f9fa);\n  color: var(--color-text, #333);\n}\n.confirm-body {\n  padding: 16px;\n  font-size: 13px;\n  color: var(--color-text, #333);\n  line-height: 1.5;\n}\n.confirm-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px 16px;\n  border-top: 1px solid var(--color-border, #eee);\n}\n.confirm-btn {\n  padding: 6px 16px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  border: 1px solid var(--color-border, #ddd);\n  background: var(--color-bg, #fff);\n  color: var(--color-text, #333);\n  transition: background 0.15s;\n}\n.confirm-btn:hover {\n  background: var(--color-bg-tertiary, #f0f0f0);\n}\n/* Enter 가 누를 단추가 어느 것인지 보여야 한다 */\n.confirm-btn:focus-visible,\n.confirm-btn:focus {\n  outline: 2px solid rgba(59, 130, 246, 0.55);\n  outline-offset: 2px;\n}\n.confirm-btn-primary {\n  background: #007bff;\n  color: #fff;\n  border-color: #007bff;\n}\n.confirm-btn-primary:hover {\n  background: #0056b3;\n}\n.confirm-btn-danger {\n  background: #dc3545;\n  color: #fff;\n  border-color: #dc3545;\n}\n.confirm-btn-danger:hover {\n  background: #c82333;\n}\n\n[data-theme=\"dark\"] .confirm-overlay { background: rgba(0,0,0,0.6); }\n[data-theme=\"dark\"] .confirm-dialog { background: var(--color-bg-tertiary); border-color: var(--color-border); }\n[data-theme=\"dark\"] .confirm-header { background: var(--color-bg-secondary); color: var(--color-text); border-color: var(--color-border); }\n[data-theme=\"dark\"] .confirm-body { color: var(--color-text); }\n[data-theme=\"dark\"] .confirm-footer { border-color: var(--color-border); }\n[data-theme=\"dark\"] .confirm-btn { background: var(--color-btn-bg); color: var(--color-text); border-color: var(--color-btn-border); }\n[data-theme=\"dark\"] .confirm-btn:hover { background: var(--color-hover); }\n/* 다크에서도 주 버튼은 색을 지킨다 — 위 규칙이 더 구체적이라 위험(빨강)·기본(파랑)까지 회색으로 덮어,\n   되돌릴 수 없는 동작(삭제·초기화)의 버튼이 「취소」 와 똑같이 보였다(화면 확인 2026-10-05) */\n[data-theme=\"dark\"] .confirm-btn-primary { background: #1f6feb; color: #fff; border-color: #1f6feb; }\n[data-theme=\"dark\"] .confirm-btn-primary:hover { background: #388bfd; }\n[data-theme=\"dark\"] .confirm-btn-danger { background: #da3633; color: #fff; border-color: #da3633; }\n[data-theme=\"dark\"] .confirm-btn-danger:hover { background: #f85149; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
